export default __webpack_public_path__ + "static/media/wine-glass-cheers.c58ca198.jpg";